import script from "./Tracking-Guias-Zoom.vue?vue&type=script&setup=true&lang=js"
export * from "./Tracking-Guias-Zoom.vue?vue&type=script&setup=true&lang=js"

import "./Tracking-Guias-Zoom.vue?vue&type=style&index=0&id=e8aa2f6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4c70acdb4c746897c15f9d0e9400da56/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8aa2f6e"]])

export default __exports__